<template>
    <form ref="registration-form" :key="$store.state.client.newDetailsFormKey">
        <b-row>
            <b-col lg="5">
                <b-row>
                    <b-col sm="4">
                        <b-img
                            src="/apps/assets/img/no_avatar.png"
                            class="photo"
                        />
                    </b-col>

                    <b-col sm="8">
                        <b-form-group
                            label="First Name:"
                            label-for="firstname"
                            label-cols-sm="4"
                        >
                            <v-search-group
                                v-if="isGroupSharing"
                                id="firstname"
                                v-model="details.firstname"
                                @update="updateFields"
                                :class="{
                                    'border-danger': errors.has('firstname')
                                }"
                            ></v-search-group>
                            <b-form-input
                                v-else
                                autofocus
                                id="firstname"
                                v-model="details.firstname"
                                :class="{
                                    'border-danger': errors.has('firstname')
                                }"
                                v-validate="'required'"
                                name="firstname"
                                class="form-control"
                                type="text"
                                placeholder="First Name (required)"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="Last Name:"
                            label-for="lastname"
                            label-cols-sm="4"
                        >
                            <b-form-input
                                id="lastname"
                                v-model="details.lastname"
                                name="lastname"
                                class="form-control"
                                type="text"
                                placeholder="Last Name (required)"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            label="Address:"
                            label-for="address"
                            label-cols-sm="4"
                        >
                            <div v-if="use_google_location">
                                <v-address-picker
                                    id="address"
                                    v-model="details.address"
                                    module="address"
                                    class="form-control"
                                    placeholder="Address (optional)"
                                    name="address"
                                />
                            </div>
                            <div v-else>
                                <v-address-picker-aws
                                    id="address"
                                    v-model="details.address"
                                    module="address"
                                    placeholder="Address (optional)"
                                    name="address"
                                />
                            </div>
                        </b-form-group>

                        <b-form-group
                            label="Zipcode:"
                            label-for="zipcode"
                            label-cols-sm="4"
                        >
                            <div v-if="use_google_location">
                                <v-address-picker
                                    id="zipcode"
                                    v-model="details.zipcode"
                                    module="zipcode"
                                    name="zipcode"
                                    class="form-control"
                                    placeholder="Zipcode (optional)"
                                />
                            </div>
                            <div v-else>
                                <b-form-input
                                    module="zipcode"
                                    id="zipcode"
                                    v-model="details.zipcode"
                                    name="zipcode"
                                    placeholder="Zipcode (optional)"
                                />
                            </div>
                        </b-form-group>

                        <b-form-group
                            label="City:"
                            label-for="city"
                            label-cols-sm="4"
                        >
                            <div v-if="use_google_location">
                                <v-address-picker
                                    id="city"
                                    v-model="details.city"
                                    module="city"
                                    class="form-control"
                                    placeholder="City (optional)"
                                    name="city"
                                />
                            </div>
                            <div v-else>
                                <b-form-input
                                    id="city"
                                    v-model="details.city"
                                    module="city"
                                    placeholder="City (optional)"
                                    name="city"
                                />
                            </div>
                        </b-form-group>

                        <b-form-group
                            label="State:"
                            label-for="state"
                            label-cols-sm="4"
                        >
                            <div v-if="use_google_location">
                                <v-address-picker
                                    id="state"
                                    v-model="details.state"
                                    module="state"
                                    name="state"
                                    class="form-control"
                                    placeholder="State (optional)"
                                />
                            </div>
                            <div v-else>
                                <b-form-input
                                    id="state"
                                    v-model="details.state"
                                    module="state"
                                    name="state"
                                    placeholder="State (optional)"
                                />
                            </div>
                        </b-form-group>

                        <b-form-group
                            label="Country:"
                            label-for="country"
                            label-cols-sm="4"
                        >
                            <div v-if="use_google_location">
                                <v-address-picker
                                    id="country"
                                    v-model="details.country"
                                    module="country"
                                    name="country"
                                    class="form-control"
                                    placeholder="Country (optional)"
                                />
                            </div>
                            <div v-else>
                                <b-form-input
                                    id="country"
                                    v-model="details.country"
                                    module="country"
                                    name="country"
                                    placeholder="Country (optional)"
                                />
                            </div>
                        </b-form-group>

                        <b-form-group
                            hidden
                            label="County:"
                            label-for="county"
                            label-cols-sm="4"
                        >
                            <div v-if="use_google_location">
                                <v-address-picker
                                    id="county"
                                    v-model="details.county"
                                    module="county"
                                    name="county"
                                    class="form-control"
                                    placeholder="County (optional)"
                                />
                            </div>
                            <div v-else>
                                <b-form-input
                                    id="county"
                                    v-model="details.county"
                                    module="county"
                                    name="county"
                                    placeholder="County (optional)"
                                />
                            </div>
                        </b-form-group>

                        <b-form-group
                            label="Birthdate:"
                            label-for="birthdate"
                            label-cols-sm="4"
                        >
                            <date-picker
                                :config="birthdatePickerOptions"
                                :placeholder="getDateFormat() + ' (optional)'"
                                v-model="formattedBirthdate"
                                class="form-control"
                                name="birthdate"
                            ></date-picker>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="7">
                <b-row>
                    <b-col sm="6">
                        <b-form-group
                            label="Home:"
                            label-for="homeCountryCode"
                            label-cols-sm="4"
                        >
                            <b-row>
                                <b-col sm="4" class="pr-0">
                                    <country-code
                                        class="form-control"
                                        :defaultValue="$root.setting.phone_code"
                                        v-model="details.home_country_code"
                                    />
                                </b-col>
                                <b-col class="pl-2">
                                    <b-form-input
                                        id="homePhone"
                                        v-model="details.home"
                                        name="homePhone"
                                        class="form-control"
                                        type="text"
                                        placeholder="Home Phone (optional)"
                                        v-validate="'international_phone'"
                                        :class="{
                                            'border-danger': errors.has(
                                                'homePhone'
                                            )
                                        }"
                                    ></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>

                        <b-form-group
                            label="Mobile:"
                            label-for="mobileCountryCode"
                            label-cols-sm="4"
                        >
                            <b-row>
                                <b-col sm="4" class="pr-0">
                                    <country-code
                                        class="form-control"
                                        :defaultValue="$root.setting.phone_code"
                                        v-model="details.mobile_country_code"
                                    />
                                </b-col>
                                <b-col class="pl-2">
                                    <b-form-input
                                        id="mobilePhone"
                                        v-model="details.mobile"
                                        name="mobilePhone"
                                        class="form-control"
                                        type="text"
                                        :placeholder="mobileFieldPlaceholder"
                                        v-validate="'international_phone'"
                                        :class="{
                                            'border-danger': errors.has(
                                                'mobilePhone'
                                            )
                                        }"
                                    ></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>

                        <b-form-group
                            label="Work:"
                            label-for="workCountryCode"
                            label-cols-sm="4"
                        >
                            <b-row>
                                <b-col sm="4" class="pr-0">
                                    <country-code
                                        class="form-control"
                                        :defaultValue="$root.setting.phone_code"
                                        v-model="details.work_country_code"
                                    />
                                </b-col>
                                <b-col class="pl-2">
                                    <b-form-input
                                        id="workPhone"
                                        v-model="details.work"
                                        name="workPhone"
                                        class="form-control"
                                        type="text"
                                        placeholder="Work Phone (optional)"
                                        v-validate="'international_phone'"
                                        :class="{
                                            'border-danger': errors.has(
                                                'workPhone'
                                            )
                                        }"
                                    ></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>

                        <b-form-group
                            label="Fax:"
                            label-for="faxCountryCode"
                            label-cols-sm="4"
                        >
                            <b-row>
                                <b-col sm="4" class="pr-0">
                                    <country-code
                                        class="form-control"
                                        :defaultValue="$root.setting.phone_code"
                                        v-model="details.fax_country_code"
                                    />
                                </b-col>
                                <b-col class="pl-2">
                                    <b-form-input
                                        id="fax"
                                        v-model="details.fax"
                                        name="fax"
                                        class="form-control"
                                        type="text"
                                        placeholder="Fax (optional)"
                                        v-validate="'international_phone'"
                                        :class="{
                                            'border-danger': errors.has('fax')
                                        }"
                                    ></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>

                        <b-form-group
                            label="Email:"
                            label-for="email"
                            label-cols-sm="4"
                        >
                            <b-form-input
                                id="email"
                                v-model="details.email"
                                name="email"
                                class="form-control"
                                type="email"
                                :placeholder="emailFieldPlaceholder"
                                :class="{
                                    'border-danger': errors.has('email')
                                }"
                                v-validate="'email'"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="Reminders:"
                            label-for="reminders"
                            label-cols-sm="4"
                        >
                            <vue-select
                                multiple
                                v-model="details.reminder_options"
                                noDrop
                                :searchable="false"
                                placeholder="Reminder Option (optional)"
                                :options="reminderOptions"
                            />
                        </b-form-group>

                        <b-form-group
                            label="Driver License:"
                            label-for="driver_license"
                            label-cols-sm="4"
                        >
                            <b-form-input
                                id="driver_license"
                                v-model="details.driver_license"
                                name="driver_license"
                                class="form-control"
                                type="text"
                                placeholder="Driver License (optional)"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="Referred By:"
                            label-for="referredBy"
                            label-cols-sm="4"
                        >
                            <vet-select
                                module="referrer"
                                v-model="details.referredBy"
                                placeholder="Referral Source (optional)"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col sm="6">
                        <b-form-group
                            label="Balance:"
                            label-for="balance"
                            label-cols-sm="4"
                        >
                            <span>{{ _toCurrency(0) }}</span>
                        </b-form-group>

                        <b-form-group
                            label="Payment Terms:"
                            label-for="paymentTerms"
                            label-cols-sm="4"
                        >
                            <b-select
                                v-model="details.payment_term"
                                :options="paymentTermsOptions"
                                text-field="value"
                                value-field="id"
                                name="paymentTerms"
                            ></b-select>
                        </b-form-group>

                        <b-form-group
                            label="Exempt From:"
                            label-for="exemptFrom"
                            label-cols-sm="4"
                        >
                            <vue-select
                                id="exemptFrom"
                                :options="exemptFromOptions"
                                v-model="details.exempt_options"
                                label="value"
                                placeholder="Select exemption (optional)"
                                multiple
                            />
                        </b-form-group>

                        <b-form-group
                            label="Status:"
                            label-for="status"
                            label-cols-sm="4"
                        >
                            <b-select
                                v-model="details.status"
                                :options="[
                                    {
                                        value: 1,
                                        text: 'Active'
                                    },
                                    {
                                        value: 0,
                                        text: 'Inactive'
                                    }
                                ]"
                                name="status"
                            ></b-select>
                        </b-form-group>

                        <b-form-group
                            label="Discounts:"
                            label-for="discount"
                            label-cols-sm="4"
                        >
                            <b-select
                                v-model="details.discounts"
                                :options="discountOptions"
                                text-field="label"
                                value-field="id"
                                name="discount"
                            ></b-select>
                        </b-form-group>

                        <b-form-group
                            label="Last Visit:"
                            label-for="lastvisit"
                            label-cols-sm="4"
                        >
                            <b-form-input
                                plaintext
                                value="Not scheduled"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            label="Next Visit:"
                            label-for="nextvisit"
                            label-cols-sm="4"
                        >
                            <b-form-input
                                plaintext
                                value="Not scheduled"
                            ></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </form>
</template>

<script>
import CountryCode from "@/module/commons/countrycode";
import VetSelect from "@/module/commons/vet-select";
import VueSelect from "vue-select";
import Reference from "@/services/reference";
import Discount from "@/services/discount";
import vAddressPicker from "@/module/commons/vet-address.vue";
import vAddressPickerAws from "@/module/commons/vet-address-aws.vue";
import vSearchGroup from "@/components/commons/search-group";
import { has, forEach } from "lodash";
import EXTENSIONS from "@/constants/extensions";

export default {
    name: "clientDetailsNew",
    components: {
        CountryCode,
        VetSelect,
        VueSelect,
        vAddressPicker,
        vAddressPickerAws,
        vSearchGroup
    },
    data() {
        return {
            birthdateFormat: "yyyy-MM-dd",
            use_google_location: true,
            paymentTermsOptions: [],
            exemptFromOptions: [],
            discountOptions: [],
            birthdatePickerOptions: {
                useCurrent: false
            },
            reminderOptions: [],
            isMobileExtensionEnabled: false
        };
    },
    computed: {
        dateFormat() {
            return this._getLuxonFormat();
        },
        mobileFieldPlaceholder() {
            if (this.isMobileExtensionEnabled && this.details.email === "") {
                return "Mobile Phone (required)";
            }
            return "Mobile Phone (optional)";
        },
        emailFieldPlaceholder() {
            if (this.isMobileExtensionEnabled && this.details.mobile === "") {
                return "Email (required)";
            }
            return "Email (optional)";
        },
        details() {
            return this.$store.getters["client/newDetails"];
        },
        isGroupSharing() {
            let setting = this.$store.getters["setting"];

            return has(setting, "business.groups")
                ? setting.business.groups.length > 0
                : false;
        },
        formattedBirthdate: {
            get() {
                return this._reformatDateDisplay(
                    this.details.birthdate,
                    this.birthdateFormat,
                    this.dateFormat
                );
            },
            set(value) {
                let date = this._reformatDateDisplay(
                    value,
                    this.dateFormat,
                    this.birthdateFormat
                );

                this.$store.commit("client/setNewDetails", {
                    birthdate: date
                });
            }
        }
    },
    watch: {
        "details.home"(value) {
            this.setCanSave();
            this.toggleReminderOption(value, this.REMINDER_TYPE.PHONE);
        },
        "details.mobile"(value) {
            this.setCanSave();
            this.toggleReminderOption(value, this.REMINDER_TYPE.PHONE);
            if (
                this._isExtensionEnabled("SMS") ||
                this._isExtensionEnabled("2_WAY_MESSAGING")
            ) {
                this.toggleReminderOption(value, this.REMINDER_TYPE.SMS);
            }
        },
        "details.work"(value) {
            this.setCanSave();
            this.toggleReminderOption(value, this.REMINDER_TYPE.PHONE);
        },
        "details.address"(value) {
            this.toggleReminderOption(value, this.REMINDER_TYPE.MAIL);
        },
        "details.email"(value) {
            this.setCanSave();
            this.toggleReminderOption(value, this.REMINDER_TYPE.EMAIL);
        },
        "details.firstname"() {
            this.setCanSave();
        },
        "details.fax"() {
            this.setCanSave();
        }
    },
    mounted() {
        this.use_google_location =
            process.env.USE_GOOGLE_LOCATION === "true" ? true : false;
        this.reminderOptions = [
            { value: this.REMINDER_TYPE.PHONE, label: "Phone" },
            { value: this.REMINDER_TYPE.EMAIL, label: "Email" },
            { value: this.REMINDER_TYPE.MAIL, label: "Mail" }
        ];

        if (
            this._isExtensionEnabled("SMS") ||
            this._isExtensionEnabled("2_WAY_MESSAGING")
        ) {
            this.reminderOptions.push({
                value: this.REMINDER_TYPE.SMS,
                label: "SMS (Text)"
            });
        }

        this.getPaymentTerms();
        this.getExempts();
        this.getDiscounts();
        this.addressPicked();
        this.setEmailPhoneRequiredMobile();
    },
    beforeDestroy() {
        this.$store.commit("client/clearNewDetails");
    },
    methods: {
        setEmailPhoneRequiredMobile() {
            this.isMobileExtensionEnabled = this._isExtensionEnabled(
                EXTENSIONS.CODE.CODE_CLIENT_MOBILE_APP
            );
        },
        isDirty() {
            return this.details.firstname || this.details.lastname;
        },
        toggleReminderOption(value, reminderType) {
            const COMMIT_NAME = "client/setNewDetails";
            const { home, work, mobile, reminder_options } = this.details;

            if (value === "") {
                let proceedExclude = false;

                // for phones (home, mobile, work):
                // if there's value for one of these thing,
                // then PHONE option will not be excluded
                if (
                    reminderType === this.REMINDER_TYPE.PHONE &&
                    home === "" &&
                    work === "" &&
                    mobile === ""
                ) {
                    proceedExclude = true;
                }

                if (reminderType !== this.REMINDER_TYPE.PHONE) {
                    proceedExclude = true;
                }

                if (proceedExclude) {
                    // exclude from selected options
                    let options = reminder_options.filter(
                        record => record.value !== reminderType
                    );

                    this.$store.commit(COMMIT_NAME, {
                        reminder_options: options
                    });
                }
            } else {
                // include, only if selected reminders still dont have the option
                let isExisted = reminder_options.find(
                    rec => rec.value === reminderType
                );

                if (!isExisted) {
                    let option = this.reminderOptions.find(
                        rec => rec.value === reminderType
                    );

                    this.$store.commit(COMMIT_NAME, {
                        reminder_options: [...reminder_options, option]
                    });
                }
            }
        },
        async getPaymentTerms() {
            const res = await Reference.getPaymentTerms();
            this.paymentTermsOptions = res.resources || [];

            // set default
            if (res.resources[0]) {
                this.details.payment_term = res.resources[0].id;
            }

            if (this.$root.setting.payment_term) {
                this.details.payment_term = this.$root.setting.payment_term;
            }
        },
        async getExempts() {
            const res = await Reference.getExemptionTypes();
            this.exemptFromOptions = res.resources || [];
        },
        async getDiscounts() {
            let options = [{ id: "", label: "No Discount" }]; // default first option
            const res = await Discount.getDiscounts();

            if (res.resource && res.resource.data) {
                // get active only discounts (status = 1)
                let activeDiscounts = res.resource.data.filter(
                    disc => disc.status === 1
                );

                activeDiscounts.forEach(opt => {
                    let label = opt.name;
                    if (opt.all_category == 1) {
                        if (opt.type === 0) {
                            label += " (" + opt.amount + "%)";
                        } else {
                            label += " ($" + opt.amount + ")";
                        }
                    }
                    opt.label = label;
                });

                options = [...options, ...activeDiscounts];
            }

            this.discountOptions = options;
        },
        updateFields(copyData) {
            if (copyData) {
                this.details.group_insert = true;
                this.details.id = copyData.id;
                this.details.lastname = copyData.lastname;

                this.details.address = copyData.address;
                this.details.city = copyData.city;
                this.details.state = copyData.state;
                this.details.zipcode = copyData.zipcode;
                this.details.country = copyData.country;

                this.details.home = copyData.home;
                this.details.home_country_code = copyData.home_country_code;
                this.details.mobile = copyData.mobile;
                this.details.mobile_country_code = copyData.mobile_country_code;
                this.details.work = copyData.work;
                this.details.work_country_code = copyData.work_country_code;
                this.details.fax = copyData.fax;
                this.details.email = copyData.email;
                this.details.driver_license = copyData.driver_license;

                this.details.birthdate = copyData.birthdate;

                if (copyData.birthdate != "") {
                    this.details.birthdate = this._reformatDateDisplay(
                        copyData.birthdate,
                        this.dateFormat,
                        this.birthdateFormat
                    );
                }

                let reminders = copyData.reminderOptions;

                forEach(reminders, function (reminder) {
                    let match = _.find(this.reminderOptions, function (option) {
                        return option;
                    });

                    if (match) {
                        this.details.reminder_options.push(match);
                    }
                });
            }
        },
        addressPicked() {
            let self = this;
            self.$root.$on("addressPicked", address => {
                if (_.isObject(address) && !_.isUndefined(address.address)) {
                    self.details.address = address.address;
                    self.details.zipcode = address.zipcode;
                    self.details.city = address.city;
                    self.details.county = address.county;
                    self.details.state = address.state;
                    self.details.country = address.country;
                }
            });
        },
        async setCanSave() {
            let valid = await this.$validator.validateAll();

            if (!valid) {
                this.$store.commit("client/setNewDetails", {
                    canSave: false
                });
            } else {
                this.$store.commit("client/setNewDetails", {
                    canSave: true
                });
            }
        }
    }
};
</script>

<style scoped>
.photo {
    /* width: 230px; */
    width: 100%;
    padding: 4px;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0, 0, 0, 0.2);
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
</style>
